export const JHARKHAND_DISTRICTS = [
  "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh", "Deoghar",
  "Giridih", "Ramgarh", "Chaibasa", "Dumka", "Palamu", "Garhwa",
  "Latehar", "Lohardaga", "Gumla", "Simdega", "Khunti", "Saraikela",
  "East Singhbhum", "West Singhbhum", "Koderma", "Chatra", "Jamtara",
  "Sahibganj", "Pakur", "Godda",
];

export const RELIGIONS = ["Hindu", "Muslim", "Christian", "Sikh", "Jain", "Buddhist", "Other"];
export const MARITAL = ["Never Married", "Divorced", "Widowed", "Awaiting Divorce"];
export const DIET = ["Vegetarian", "Non-Vegetarian", "Eggetarian", "Jain", "Vegan"];
export const EDUCATION = [
  "High School", "Diploma", "B.A", "B.Com", "B.Sc", "B.Tech / B.E", "MBBS",
  "MBA", "M.A", "M.Sc", "M.Tech", "CA", "PhD", "Other",
];
export const RASHIS = ["Mesha", "Vrishabha", "Mithuna", "Karka", "Simha", "Kanya",
  "Tula", "Vrishchika", "Dhanu", "Makara", "Kumbha", "Meena"];
export const NAKSHATRAS = [
  "Ashwini", "Bharani", "Krittika", "Rohini", "Mrigashira", "Ardra",
  "Punarvasu", "Pushya", "Ashlesha", "Magha", "Purva Phalguni", "Uttara Phalguni",
  "Hasta", "Chitra", "Swati", "Vishakha", "Anuradha", "Jyeshtha",
  "Mula", "Purva Ashadha", "Uttara Ashadha", "Shravana", "Dhanishta", "Shatabhisha",
  "Purva Bhadrapada", "Uttara Bhadrapada", "Revati",
];

// Block (CD-block / tehsil) lists per Jharkhand district — the platform's key differentiator.
export const DISTRICT_BLOCKS = {
  "Ranchi": ["Ranchi Sadar", "Kanke", "Namkum", "Ratu", "Bero", "Bundu", "Tamar", "Sonahatu", "Rahe", "Silli", "Angara", "Ormanjhi", "Mandar", "Chanho", "Burmu", "Lapung", "Itki", "Nagri", "Khelari"],
  "Jamshedpur": ["Jamshedpur (Sadar)", "Potka", "Patamda", "Boram", "Ghatshila", "Musabani", "Dumaria", "Baharagora", "Dhalbhumgarh", "Chakulia", "Gurabandha"],
  "East Singhbhum": ["Jamshedpur (Sadar)", "Potka", "Patamda", "Boram", "Ghatshila", "Musabani", "Dumaria", "Baharagora", "Dhalbhumgarh", "Chakulia", "Gurabandha"],
  "Dhanbad": ["Dhanbad Sadar", "Baghmara", "Baliapur", "Govindpur", "Nirsa", "Topchanchi", "Tundi", "Purbi Tundi", "Egarkund", "Kaliasole"],
  "Bokaro": ["Chas", "Bokaro", "Chandankiyari", "Jaridih", "Petarwar", "Kasmar", "Gomia", "Nawadih", "Bermo"],
  "Hazaribagh": ["Hazaribagh Sadar", "Barhi", "Barkagaon", "Katkamsandi", "Ichak", "Chouparan", "Padma", "Keredari", "Tatijhariya", "Bishnugarh", "Churchu", "Daru", "Chalkusha", "Katkamdag"],
  "Deoghar": ["Deoghar Sadar", "Mohanpur", "Sarwan", "Sarath", "Madhupur", "Margomunda", "Devipur", "Palojori", "Karon", "Sonaraithari"],
  "Giridih": ["Giridih Sadar", "Dumri", "Bagodar", "Birni", "Bengabad", "Gawan", "Tisri", "Deori", "Dhanwar", "Jamua", "Pirtand", "Sariya", "Gandey"],
  "Ramgarh": ["Ramgarh", "Mandu", "Patratu", "Gola", "Dulmi", "Chitarpur"],
  "Chaibasa": ["Chaibasa Sadar", "Tantnagar", "Khuntpani", "Jhinkpani", "Chakradharpur", "Bandgaon", "Sonua", "Goilkera", "Manoharpur", "Noamundi", "Jagannathpur", "Manjhgaon", "Tonto", "Hatgamharia", "Kumardungi", "Anandpur", "Gudri"],
  "West Singhbhum": ["Chaibasa Sadar", "Tantnagar", "Khuntpani", "Jhinkpani", "Chakradharpur", "Bandgaon", "Sonua", "Goilkera", "Manoharpur", "Noamundi", "Jagannathpur", "Manjhgaon", "Tonto", "Hatgamharia", "Kumardungi", "Anandpur", "Gudri"],
  "Dumka": ["Dumka", "Jama", "Jarmundi", "Ramgarh", "Gopikandar", "Kathikund", "Shikaripara", "Masalia", "Ranishwar", "Saraiyahat"],
  "Palamu": ["Medininagar (Daltonganj)", "Chainpur", "Satbarwa", "Bishrampur", "Chhatarpur", "Patan", "Hussainabad", "Hariharganj", "Haidarnagar", "Pandwa", "Pipra", "Manatu", "Tarhasi", "Nawa Bazar", "Lesliganj", "Panki", "Mohammadganj"],
  "Garhwa": ["Garhwa", "Ranka", "Bhawanathpur", "Nagar Untari", "Dhurki", "Meral", "Majhiaon", "Bishunpura", "Kandi", "Chinia", "Ramkanda", "Bhandaria", "Sagma", "Kharaundhi", "Dandai", "Ketar", "Ramna"],
  "Latehar": ["Latehar", "Balumath", "Barwadih", "Manika", "Chandwa", "Garu", "Mahuadanr", "Herhanj", "Bariatu"],
  "Lohardaga": ["Lohardaga", "Kuru", "Bhandra", "Senha", "Kisko", "Kairo", "Peshrar"],
  "Gumla": ["Gumla", "Sisai", "Bharno", "Raidih", "Bishunpur", "Chainpur", "Ghaghra", "Palkot", "Basia", "Kamdara", "Jari (Albert Ekka)", "Dumri"],
  "Simdega": ["Simdega", "Kolebira", "Bano", "Jaldega", "Thethaitangar", "Kurdeg", "Bolba", "Bansjore", "Pakartanr", "Kersai"],
  "Khunti": ["Khunti", "Murhu", "Torpa", "Karra", "Arki", "Rania"],
  "Saraikela": ["Saraikela", "Kharsawan", "Chandil", "Ichagarh", "Nimdih", "Kuchai", "Gamharia", "Rajnagar", "Kukru"],
  "Koderma": ["Koderma", "Jainagar", "Markacho", "Satgawan", "Chandwara", "Domchanch"],
  "Chatra": ["Chatra", "Hunterganj", "Pratappur", "Kanhachatti", "Simaria", "Tandwa", "Itkhori", "Mayurhand", "Lawalong", "Gidhaur", "Kunda", "Pathalgada"],
  "Jamtara": ["Jamtara", "Narayanpur", "Kundhit", "Nala", "Fatehpur", "Karmatanr"],
  "Sahibganj": ["Sahibganj", "Rajmahal", "Borio", "Barhait", "Taljhari", "Mandro", "Pathna", "Udhwa", "Barharwa"],
  "Pakur": ["Pakur", "Maheshpur", "Littipara", "Amrapara", "Hiranpur", "Pakuria"],
  "Godda": ["Godda", "Mahagama", "Meherma", "Boarijore", "Sundarpahari", "Pathargama", "Poraiyahat", "Thakurgangti", "Basantrai"],
};

export const blocksFor = (district) => DISTRICT_BLOCKS[district] || [];

// ── Castes / Communities prominent in Jharkhand ─────────────────────────────
// Grouped for readability; used in ComboSelect (searchable dropdown + custom entry)
export const JHARKHAND_CASTES = [
  // General / Upper castes
  "Brahmin",
  "Maithil Brahmin",
  "Kanyakubja Brahmin",
  "Saryupareen Brahmin",
  "Sakaldwipi Brahmin",
  "Gaur Brahmin",
  "Bhumihar Brahmin",
  "Utkal Brahmin",
  "Bhumihar",
  "Rajput / Kshatriya",
  "Kayastha",
  "Bania / Vaishya",
  // OBC castes (Jharkhand Central List)
  "Abdal",
  "Aghori",
  "Amaat",
  "Bagdi, Bagti",
  "Bakho (Muslim)",
  "Banpar",
  "Barai",
  "Barhai, Vishwakarma",
  "Bari",
  "Beldar",
  "Bhar",
  "Bhaskar",
  "Bhat, Bhatt, Bhat (Muslim)",
  "Bhathiara (Muslim)",
  "Bind",
  "Bhuihar, Bhuiyar",
  "Chain, Chayeen",
  "Chapota",
  "Chandrabanshi (Kahar)",
  "Chanou",
  "Christian converts from Other Backward Classes",
  "Christian converts from Scheduled Castes",
  "Churihar (Muslim)",
  "Dafali (Muslim)",
  "Dangi",
  "Devhar",
  "Dhamin",
  "Dhanuk",
  "Dhanwar",
  "Dhekaru",
  "Dhimar",
  "Dhobi (Muslim)",
  "Dhunia (Muslim)",
  "Gaddi",
  "Gandharb, Gandarbh",
  "Gangai (Nagesh)",
  "Gangota, Gangoth",
  "Ghatwar",
  "Godi (Chhava)",
  "Goud",
  "Gulgaliya",
  "Idrisi or Darzi (Muslim)",
  "Jogi (Jugi)",
  "Kadar",
  "Kaivartta, Kaibartta",
  "Kagzi",
  "Kalandar",
  "Kamar (Lohar, Karmakar), Visvakarma",
  "Kanu",
  "Kapadia",
  "Kasab (Kasai) (Muslim)",
  "Kewat (Keot)",
  "Khangar",
  "Khatik",
  "Khatwa",
  "Khatwe",
  "Khelta",
  "Khetauri, Khatauri",
  "Kochh",
  "Korku",
  "Kosta, Koshta",
  "Kulahia",
  "Kurmi, Kurmi (Mahto)",
  "Kushwaha (Koeri)",
  "Laheri",
  "Madar",
  "Madari (Muslim)",
  "Mehtar, Halalkhor, (Muslim) Lalbegi, Bhangi",
  "Majhwar",
  "Malar (Malhor)",
  "Mali (Malakar)",
  "Mallah (Surhiya), Kewat Murawari",
  "Mangar (Magar)",
  "Markande",
  "Maulik",
  "Mauriari, Mauriaro, Mauriara",
  "Miriasin (Muslim)",
  "Mirshikar (Muslim)",
  "Momin (Muslim), Julaha, Ansari",
  "Mukri (Mukeri) (Muslim)",
  "Nagar (This does not include Maithili Brahmins and immigrant Nagars from other States who are Brahmins and Baniyas)",
  "Nai",
  "Naiya",
  "Nalband (Muslim)",
  "Namshudra",
  "Nat (Muslim)",
  "Nonia, Nunia",
  "Pahira",
  "Pal (Bherihar-Gaderi), Gaderia",
  "Pamaria (Muslim)",
  "Pandi",
  "Pinganiya",
  "Pradhan",
  "Prajapati (Kumbhar)",
  "Rajbanshi (Risiya and Poliya)",
  "Rajbhar",
  "Rajdhobi",
  "Rangwa",
  "Rangrez (Muslim)",
  "Rauttiya",
  "Rayeen or Kunjra (Muslim)",
  "Sauta (Sota)",
  "Sayee (Muslim)",
  "Shekhra",
  "Shershahbadi",
  "Shivhari",
  "Sonar, Sunar",
  "Sukiyar",
  "Tamariya",
  "Tamoli, Tamboli",
  "Tanti (Tatwa), Tati, Tatin",
  "Teli",
  "Tharu",
  "Thakurai (Muslim)",
  "Tikulhar",
  "Tiyar",
  "Turha",
  "Yadav (Gwala, Ahir, Gope), Mehar, Sadgop",
  "Saikalgar (Sikligar) (Muslim)",
  "Chik (Muslim)",
  "Bairagi",
  "Sudi, Halwai, Roniyar, Pansari, Modi, Kasera, Kesarwani, Thathera, Patwa, Sinduriya- Bania, Mahuri Vaishya, Awadh-Bania/Adrakhi, Agrahari-Vaishya",
  "Dhankar",
  "Kalal, Eraqui",
  "Kalwar",
  "Parya",
  "Kaura",
  "Chhipi",
  "Mayra(Maira) Modak",
  "Late",
  "Kunai",
  "Pushpanamit",
  "Jhora",
  "Laxmi Narayan Gola",
  // SC castes
  "Bantar (बांतर)",
  "Bauri (बौर)",
  "Bhogta (भोगता)",
  "Bhuiya (भुइया)",
  "Chamar, Mochi (चमार , मोची)",
  "Chaupal (चौपाल)",
  "Dabgar (डावगर)",
  "Dhobi (धोबी)",
  "Dom, Dhangad (डॉम , धनगद)",
  "Dusadh, Dhari, Dharhi (दसाध, धारी, धरही)",
  "Ghasi (घासी)",
  "Halalkhor (हलालखोर)",
  "Hari, Mehtar, Bhangi (हारी , मेहतर ,भंगी)",
  "Kanjar (कंजर)",
  "Kurariar (कुररियार)",
  "Lalbegi (लालबेगी)",
  "Musahar (मुशहर)",
  "Nat (नट)",
  "Pan, Sawasi (पान ,स्वासी)",
  "Pasi (पासी)",
  "Rajwar (रजवार)",
  "Turi (तुरी)",
  // Scheduled Tribes (Jharkhand specific)
  "Asur, Agaria (असुर, अगरिया)",
  "Baiga (बैगा)",
  "Banjara (बंजारा)",
  "Bathudi (बथुदी)",
  "Bedia (बेदिया)",
  "Binjhia (बिंझिया)",
  "Birhor (बिरहोर)",
  "Birjia (बिरजिया)",
  "Chero (चेरो)",
  "Chik Baraik (चिक बारिक)",
  "Gond (गोंड)",
  "Gorait (गोरईट)",
  "Ho (हो)",
  "Karmali (करमाली)",
  "Kharia, Dhelki Kharia, Dudh Kharia, Hill Kharia (खरिया, ढेलकी खरिया, दूध खरिया, हिल खरिया)",
  "Kharwar (खरवार)",
  "Khond (खोंड)",
  "Kisan, Nagesia (किसान, नगेसिया)",
  "Kora, Mudi-Kora (कोरा, मुडी-कोरा)",
  "Korwa (कोरवा)",
  "Lohra (लोहरा)",
  "Mahli (महली)",
  "Mai Paharia, Kumarbhag Paharia (मै पहरिया, कुमरभाग पहाड़िया)",
  "Munda, Patar (मुंडा, पतार)",
  "Oraon, Dhangar (ओराओं, धनगर)",
  "Parhaiya (पहाड़िया)",
  "Santal (संताल)",
  "Sauria Paharia (सउरिया पहाड़िया)",
  "Savar (सावर)",
  "Bhumij (भूमिज)",
  "Kawar (कवर)",
  "Kol (कोल)",
  // Sarna / Tribal traditions
  "Sarna",
  // Muslim communities
  "Sheikh",
  "Ansari / Julaha",
  "Syed",
  "Pathan",
  "Qureshi",
  // Christian communities
  "Christian (General)",
];

// ── Occupations / Job types ────────────────────────────────────────────────
export const OCCUPATIONS = [
  // Government & Defence
  "Government Employee",
  "IAS / IPS / IFS Officer",
  "Army / Navy / Air Force",
  "Police Officer",
  "Government Teacher",
  "Bank Employee (Government)",
  "Railway Employee",
  // Private Sector
  "Software Engineer / IT",
  "Doctor / Physician",
  "Engineer (Non-IT)",
  "Chartered Accountant (CA)",
  "Lawyer / Advocate",
  "Teacher / Professor (Private)",
  "Nurse / Paramedic",
  "MBA Professional",
  "Sales / Marketing",
  "Accountant",
  "Bank Employee (Private)",
  "HR Professional",
  // Business / Self-Employed
  "Business Owner",
  "Shop Owner / Trader",
  "Contractor",
  "Real Estate",
  "Transport / Logistics",
  "Agriculture / Farming",
  "Mining Industry",
  // Blue collar / Skilled trades
  "Driver",
  "Mechanic",
  "Electrician",
  "Plumber",
  "Tailor",
  "Carpenter",
  "Mason / Construction",
  // Other
  "Student",
  "Homemaker",
  "Retired",
  "Freelancer / Self-Employed",
  "Not Working",
];

